import { Card, CardBody, Container, Spinner } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { usePettyCashBalance } from "hooks/usePettyCashMaster"
import { formatCurrency } from "utils/formatCurrency"

const PettyCashBalance = () => {
  document.title = "Petty Cash Balance"

  const { data: response, isLoading } = usePettyCashBalance()
  const balance = response?.data

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Petty Cash" breadcrumbItem="Balance" />

        {isLoading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : (
          <Card className="border-0 shadow-sm" style={{ maxWidth: 400 }}>
            <CardBody className="text-center py-5">
              <div className="avatar-lg rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center bg-primary bg-opacity-10">
                <i className="mdi mdi-cash-multiple text-primary font-size-28" />
              </div>
              <h6 className="text-muted fw-semibold mb-2 text-uppercase" style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}>Current Balance</h6>
              <h2 className={`fw-bold mb-0 ${(balance?.balance ?? 0) < 0 ? "text-danger" : "text-success"}`}>
                {formatCurrency(balance?.balance ?? 0, "BDT")}
              </h2>
              {balance?.updated_at && (
                <p className="text-muted small mt-2 mb-0">Last updated: {new Date(balance.updated_at).toLocaleString()}</p>
              )}
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  )
}

export default PettyCashBalance
